/* Saves Paypal onboarding info */
import React, { useEffect, useState } from 'react';
import Layout from '../core/Layout';
import { useLocation } from 'react-router-dom';
import { savePaypal } from './apiUser';
import { isAuthenticated } from '../auth';

const SavePaypal = () => {
    const search = useLocation().search;
    const { user: { _id }, token } = isAuthenticated();
    
    const merchantIdInPayPal = new URLSearchParams(search).get('merchantIdInPayPal');
    const permissionsGranted = new URLSearchParams(search).get('permissionsGranted');
    const accountStatus = new URLSearchParams(search).get('accountStatus');
    const consentStatus = new URLSearchParams(search).get('consentStatus');
    const productIntentId = new URLSearchParams(search).get('productIntentId');
    const isEmailConfirmed = new URLSearchParams(search).get('isEmailConfirmed');
    const returnMessage = new URLSearchParams(search).get('returnMessage');
    const riskStatus = new URLSearchParams(search).get('riskStatus');

    const paypalInfo = {
         merchantIdInPayPal,
         permissionsGranted,
         accountStatus,
         consentStatus,
         productIntentId,
         isEmailConfirmed,
         returnMessage,
         riskStatus,
    };

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        console.log(paypalInfo);

        savePaypal(_id, paypalInfo, token).then(data => {
            setLoading(false);
            if (data.error) {
                console.log('err');
            }
            else {
                console.log('succ');
            }
        });
    },[])

    return (
        <Layout>
            {loading ? 
                <p> loading... </p>
                :
                <p> successfully saved paypal info </p>
            }
        </Layout>
        
    );
};

export default SavePaypal;
